var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24966_132670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 12.4948H10.8333V14.1615H9.16667V12.4948ZM9.16667 5.82812H10.8333V10.8281H9.16667V5.82812ZM15.8333 2.49479H12.35C12 1.52812 11.0833 0.828125 10 0.828125C8.91667 0.828125 8 1.52812 7.65 2.49479H4.16667C4.05 2.49479 3.94167 2.50312 3.83333 2.52812C3.50833 2.59479 3.21667 2.76146 2.99167 2.98646C2.84167 3.13646 2.71667 3.31979 2.63333 3.51979C2.55 3.71146 2.5 3.92812 2.5 4.16146V15.8281C2.5 16.0531 2.55 16.2781 2.63333 16.4781C2.71667 16.6781 2.84167 16.8531 2.99167 17.0115C3.21667 17.2365 3.50833 17.4031 3.83333 17.4698C3.94167 17.4865 4.05 17.4948 4.16667 17.4948H15.8333C16.75 17.4948 17.5 16.7448 17.5 15.8281V4.16146C17.5 3.24479 16.75 2.49479 15.8333 2.49479ZM10 2.28646C10.3417 2.28646 10.625 2.56979 10.625 2.91146C10.625 3.25312 10.3417 3.53646 10 3.53646C9.65833 3.53646 9.375 3.25312 9.375 2.91146C9.375 2.56979 9.65833 2.28646 10 2.28646ZM15.8333 15.8281H4.16667V4.16146H15.8333V15.8281Z",
    fill: "#DD6B20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24966_132670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRequest);
export default __webpack_public_path__ + "static/media/cancel_request.7e68188b635aa3340ad98b26c221100e.svg";
export { ForwardRef as ReactComponent };